import React, { createElement } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import './index.css';
// Ensure viewport meta tag exists for mobile responsiveness
if (!document.querySelector('meta[name="viewport"]')) {
  const meta = document.createElement('meta');
  meta.name = 'viewport';
  meta.content = 'width=device-width, initial-scale=1.0, viewport-fit=cover';
  document.head.appendChild(meta);
} else {
  const existing = document.querySelector('meta[name="viewport"]') as HTMLMetaElement;
  existing.content = 'width=device-width, initial-scale=1.0, viewport-fit=cover';
}
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode data-id="element-54">
    <BrowserRouter data-id="element-55">
      <App data-id="element-56" />
    </BrowserRouter>
  </React.StrictMode>);